import script from "./centralizedProductsCommons.vue?vue&type=script&lang=js"
export * from "./centralizedProductsCommons.vue?vue&type=script&lang=js"

const __exports__ = script;

export default __exports__